import Box from "@mui/material/Box";
import '../styles/chat.scss'
import TaskManage from "./task_manage";
import Chat from "./chat";
import React, {useCallback, useEffect, useReducer, useRef, useState} from "react";
import {IconButton, Tab, Tabs} from "@mui/material";
import {socketService} from "../socket/SocketService";
import {TaskFlowContext} from "../context/TaskFlowContext";
import ReactMarkdown from 'react-markdown';
import {
    analysisTaskProcess, AnalysisTaskSubProcess, BatchSubTaskProcess,
    CommandType,
    ConversionType,
    ExtraProps, FetchImagesSubTaskProcess, FetchImagesTaskProcess, GenerateTagsTaskProcess,
    taskProcess,
    taskProcessList,
    TaskStatusType,
    TriggerType
} from "../types/taskFlow.types"
import {
    deleteLocalConversionId,
    deleteLocalStorage,
    getLocalConversionId,
    getLocalStorage,
    setLocalStorage
} from "../util/storage";
import {useSocketCommands} from "../hooks/useSocketCommands";
import {
    getActiveConversion,
    getConversionHistory,
    getConversionList,
    updateTaskParams,
    updateTaskStatus
} from "../api/task";
import {Editor} from "@tldraw/tldraw";
import {LoginProps} from "../types/authority";
import {useCanvasControl} from "../hooks/useCanvasControl";
import {TLShapeId} from "@tldraw/tlschema";
import { debounce } from 'lodash';
import {getChangeSet, uploadCanvasJson} from "../api/common";
import {useLazyLoad} from "../hooks/useLazyLoad";
import CloseIcon from '@mui/icons-material/Close';
import HangingChat from "./chat/hangingChat";
import Fade from "@mui/material/Fade";
import {AppDispatch, RootState} from "../store";
import {useDispatch, useSelector} from "react-redux";
import {useCanvas2Control} from "../hooks/useCanvas2Control";
import {setGlobalMessage, setSelectCanvasImage, setSnackbarOpen} from "../store/taskSlice";
import { Snackbar, Alert } from '@mui/material';
import {setCurrentStepId} from "../store/drawSlice";
import HoverChat from "./chat/hoverChat";
import HoverChatButton from "./chat/hoverChatButton";
import HoverChatButtonForCard from "./chat/hoverChatButtonForCard"
import HoverChatButtonForImage from "./chat/hoverChatButtonForImage"
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from 'react-router-dom';
import {caseBoardInfoProps} from "../types/board.types";
import {getCategory, getStyleDetail, getStyleList, getSuggestions} from "../api/selectStyles";
import {
    setCurrentStrategyCode,
    setCurrentStyleId, setInitPrefabricatedChat, setPrefabricatedChat,
    setStyleCategory,
    setStyleDetail,
    setStyleList
} from "../store/styleSlice";
import {fetchMemberInfoAsync} from "../store/memberSlice";


export default function ChatContainer(props: {editor?: Editor, boardInfo?: caseBoardInfoProps | null, controlHistory: (id: number)=> void, openHistoryTab: number}) {
    const [conversionValue, setValue] = React.useState<ConversionType>(ConversionType.HISTORY);

    const {editor, controlHistory, openHistoryTab, boardInfo} = props;

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const location = useLocation();

    const navigate = useNavigate();

    const queryParams = new URLSearchParams(location.search);
    const boardId = queryParams.get('boardId');

    const taskProcessCacheRef = useRef<taskProcess[] | null>(null);

    const snackbarOpen = useSelector((state: RootState) => state.task.snackbarOpen);

    const globalMessage = useSelector((state: RootState) => state.task.globalMessage);

    const [conversionId, setConversionId] = React.useState<string | null>(null);

    const [taskListProcessCache, setTaskListProcess] = React.useState<taskProcessList[] | null>(null)

    const [conversionHistoryDetail, setConversionHistoryDetail] = React.useState<(taskProcess[] | null)[]>([])

    const [loading, setLoading] = React.useState(false);

    const [prompt, setPrompt] = React.useState<string>('');

    const [triggerChangeSet, setTriggerChangeSet] = React.useState(false);

    const messageQueueRef = useRef<any[]>([]);
    const isProcessing = useRef(false);
    const isPullLock = useRef(false);


    const {analysis, getConversionId} = useSocketCommands()

    const selectCanvasImage = useSelector((state: RootState) => state.task.canvasImage);

    const { stepsProcess, stepsContainer, setLabelToFrame, fitFrameContainer, redrawYAxis, replaceLabelsFrame, replaceImagesFrame, updateMainContainerStatus, syncCanvasData , setLabelToFrameNotDependent, replaceDialogFrame, replaceDescribeFrame} = useCanvasControl(editor);

    const { drawSecondFetchImages, updateReversion, getCurrentVersion } = useCanvas2Control(editor)

    const styleDetail = useSelector((state: RootState) => state.style.styleDetail);

    const level2TaskId = useSelector((state: RootState) => state.task.level2TaskId);

    const parentStepId = useSelector((state: RootState) => state.draw.currentStepId)

    const useInfoStr = getLocalStorage('userInfo');
    const userInfo = useInfoStr ? JSON.parse(useInfoStr) as LoginProps : null;

    const clientId = userInfo?.uuid

    const searchParams = new URLSearchParams(window.location.search);

    const {replaceDomImageSrc} = useLazyLoad(editor)

    const sleep = (ms: number): Promise<void> => {
        return new Promise(resolve => setTimeout(resolve, ms));
    };

    const processQueue = async () => {
        if (isProcessing.current) return;
        isProcessing.current = true;

        while (messageQueueRef.current.length > 0) {
            const data = messageQueueRef.current.shift();
            try {
                await handleTaskFlowStatus(data);
            } catch (error) {
                console.error('Error processing message:', error);
            } finally {
                await sleep(300);
               // const now = new Date();
                // console.log(`[${now.toTimeString().split(' ')[0]}.${now.getMilliseconds()}] Message:`, data.data);
            }
        }

        if (!isPullLock.current) isProcessing.current = false;
    };


    const enqueueMessage = (data: any, moveForward?: boolean) => {
        if (moveForward) {
            messageQueueRef.current = [...data, ...messageQueueRef.current];
        }else {
            if (data.trigger === 'batchEventPush') { // 进行批处理
                const events = data.data.map((event: any, index: number)=>{
                    return {...data, ...event, reversion: parseFloat(`${data.reversion}.${index}`)}
                })
                messageQueueRef.current = [...messageQueueRef.current, ...events];
            }else {
                messageQueueRef.current = [...messageQueueRef.current, data];
            }
        }
        processQueue();
    };

    type TaskProcessAction =
        | { type: 'ADD_PROCESS'; payload: { process: taskProcess } }
        | { type: 'UPDATE_PROCESS'; payload: { taskId: number; status?: any; extra?: ExtraProps } }
        | { type: 'SET_TASK_PROCESS'; payload: { processes: taskProcess[] } };

    const taskProcessReducer = (
        state: taskProcess[] | null,
        action: TaskProcessAction
    ): taskProcess[] | null => {
        let newState;
        switch (action.type) {
            case 'ADD_PROCESS':
                newState = state ? [...state, action.payload.process] : [action.payload.process];
                break;
            case 'UPDATE_PROCESS':
                if (!state) return state;
                newState = state.map(item => {
                    if (item.id === action.payload.taskId) {
                        return {
                            ...item,
                            ...(action.payload.status || {}),
                            ...(action.payload.extra ? { extra: action.payload.extra } : {})
                        };
                    }
                    return item;
                });
                break;
            case 'SET_TASK_PROCESS':
                newState = action.payload.processes;
                break;
            default:
                return state;
        }
        taskProcessCacheRef.current = newState;
        return newState;
    };

    const redrawYAxisRef = useRef<number | null>(null);


    const [taskProcessCache, dispatchTaskProcess] = useReducer(taskProcessReducer, null);


    const handleSetTaskProcess = async (process: taskProcess) => {
        dispatchTaskProcess({ type: 'ADD_PROCESS', payload: { process } });
    };

    const changeTaskProcess = async (taskId: number, status: any, extra?: ExtraProps) => {
        dispatchTaskProcess({ type: 'UPDATE_PROCESS', payload: { taskId, status, extra } });
    };

    const changeTaskListProcess = (status: 'active' | 'inactive') => {
        const conversationId = getLocalConversionId(boardId as string);
        const changeMap = taskListProcessCache?.map(item=>{
            return item.conversationId === conversationId ? {...item, status} : item
        })
        changeMap && setTaskListProcess(changeMap);
    }

    const handleSetPrompt = (topic: string) => {
        setPrompt(topic)
    }

    useEffect(() => {
        conversionHistoryDetail.forEach(history => {
            history?.forEach(item => {
                if (item.id === level2TaskId) {
                    requestAnimationFrame(() => {
                        drawSecondFetchImages(item);
                    });
                }
            });
        });
    }, [level2TaskId]);

    useEffect(() => {
        const conversationId = getLocalConversionId(boardId as string);
        if (taskProcessCache && conversationId && taskProcessCache.length > 0) {
            setConversionHistoryDetail(prevHistory => {
                if (!prevHistory) return [taskProcessCache];

                const index = prevHistory.findIndex(item => {
                    return item?.length ? item.find(val => val.conversationId === conversationId) : false;
                });

                if (index > -1) {
                    // 使用函数式更新，创建新数组并替换指定位置
                    return prevHistory.map((item, i) =>
                        i === index ? taskProcessCache : item
                    );
                } else {
                    // 使用函数式更新，追加新数据
                    return [...prevHistory, taskProcessCache];
                }
            });
        }
    }, [taskProcessCache, boardId]); // 只依赖 taskProcessCache

    const fetchAllConversionHistories = async (conversionIds: string[]) => {
        try {
            const historyTask = await Promise.all(
                conversionIds.map(id => getConversionHistory(id))
            );

            return historyTask.map(subTask => {
                return subTask?.map(val => {
                    return {...val, response: JSON.parse(val.response as unknown as string), extra: val.extra ? JSON.parse(val.extra as unknown as string) : val.extra };
                })
            }) as (taskProcess[] | null)[]
        } catch (error) {
            console.error('Failed to fetch conversion histories:', error);
            return [];
        }
    };

    const fetchConversionList = async () => {
        if (clientId && boardId) {
            getConversionList(clientId, boardId).then(async item => {
                const conversionIds: string[] = []
                const taskList = item?.map(val => {
                    conversionIds.push(val.conversationId)
                    return {...val, status: val.status};
                })
                const allHistories = await fetchAllConversionHistories(conversionIds);
                setConversionHistoryDetail(allHistories)
                setTaskListProcess(taskList || null)
            })
        }
    }

    const syncActiveConversion = (conversionId?: string, boardId?: string) => {
        if (conversionId && boardId){
            isProcessing.current = true;
            isPullLock.current = true;
            setLocalStorage('conversionId', conversionId, boardId);
            getSuggestions(conversionId).then(item=>{
                dispatch(setInitPrefabricatedChat(item))
            })
            getConversionHistory(conversionId).then(item => {
                const task = item?.map(val => {
                    return {...val, response: JSON.parse(val.response as unknown as string), extra: val.extra ? JSON.parse(val.extra as unknown as string) : val.extra };
                })
                syncCanvasData(task as taskProcess[])

                const getLastStepId = [...task as taskProcess[]].reverse().find((item)=>{return item.stepId})

                if (getLastStepId) {
                    dispatch(setCurrentStepId(getLastStepId.stepId as string))
                }

                dispatchTaskProcess({ type: 'SET_TASK_PROCESS', payload: { processes: task || [] } }); // 使用 reducer 设置完整数组
                setTriggerChangeSet(true)
            });
        }else {
            deleteLocalConversionId(boardId)
        }
    }

/*    useEffect(()=>{
        fetchConversionList().then()
    },[clientId, editor, boardId])*/


    function compareVersionStrings(version1: string, version2: string): number {
        const v1Parts = version1.split('.').map(Number);
        const v2Parts = version2.split('.').map(Number);

        for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
            const v1Part = v1Parts[i] || 0;
            const v2Part = v2Parts[i] || 0;

            if (v1Part > v2Part) return 1;
            if (v1Part < v2Part) return -1;
        }

        return 0;
    }


    const getPlanTaskId = useCallback(() => {
        const planTask = [...(taskProcessCacheRef.current || [])].reverse()?.find(task => task.triggerCmd === CommandType.ANALYSIS );
        return planTask?.id ?? 0
    }, [taskProcessCacheRef])

    const getTaskName = useCallback((taskId: number) => {
        const planTask = taskProcessCacheRef.current?.find(task => task.id === taskId);
        return planTask?.triggerCmd ?? ''
    }, [taskProcessCacheRef])

    const getBatchInfo = useCallback((batchId: string, cardIdInDify: string): {direction: 'vertical' | 'horizontal', index: number, batchCount: number, batchId: string} => {
        const planTask = [...taskProcessCacheRef.current || []].reverse()?.find(task => task.batchId === batchId && task.triggerCmd === CommandType.BATCH);
        if (planTask) {
            const response = planTask.response as unknown as BatchSubTaskProcess;

            const index = response.cardIdsInDify.indexOf(cardIdInDify)
            if (response.type === "horizontal" && index > -1) {
                return {direction: 'horizontal', index, batchCount: response.cardIdsInDify.length || 1, batchId}
            }
        }
        return {direction: 'vertical', index: 0, batchCount: 1, batchId}
    }, [taskProcessCacheRef])

    const saveCanvas = debounce(async ()=>{
        const snapshot = editor?.store.getSnapshot();
        const jsonString = JSON.stringify(snapshot);
        await uploadCanvasJson(clientId as string, jsonString)
    }, 600);

    const dispatch: AppDispatch = useDispatch()

    useEffect(() => {
        socketService.on('message', enqueueMessage);
        return () => socketService.off('message', enqueueMessage);
    }, [taskProcessCache, prompt, taskListProcessCache, level2TaskId, selectCanvasImage, parentStepId, boardId, styleDetail]);

    const handleTaskFlowStatus = async (data: any) => {
        const trigger = data.trigger
        const command = data?.data?.taskName;
        const stepId = data?.data?.stepId;
        const parentStepId = data?.data?.parentStepId;
        const conversationId = getLocalConversionId(boardId as string);
        const code = data?.data?.code;
        const message = data?.data?.message;
        const versionId = data?.reversion;
        const globalCode = data.code
        const i18nKey = data?.data?.i18nKey

        if (versionId) {
            const currentVersion = getCurrentVersion(boardId as string);

            setLoading(true);

            if (!compareVersionStrings(versionId.toString(), currentVersion.toString())) {
              //  return
            }else {
                /* const dValue = versionId - currentVersion;
                if (dValue > 1) {
                    const specifyVersions = Array.from(
                        { length: versionId - currentVersion },
                        (_, i) => currentVersion + i + 1
                    ).join(',');
                    await getChangeSetList(boardId as string, undefined, specifyVersions, 1);
                    return;
                }*/
                updateReversion(versionId, boardId as string)
            }
        }

        if (globalCode === 500) {
            setLoading(false)
            dispatch(setSnackbarOpen({open: true, message: t(data.i18nKey)}));
            return;
        }else if (code === 500) {
            setLoading(false)
            dispatch(setSnackbarOpen({open: true, message: t(i18nKey)}));
            return;
        }

        // 通用的状态处理
        const handleTaskStatus = (commandType: CommandType) => {
            if (!data.data) return;
            handleSetTaskProcess({
                triggerCmd: commandType,
                conversationId,
                ...data.data,
                response: data.data.response ? JSON.parse(data.data.response) : null,
                ...(commandType === CommandType.ANALYSIS ? {content: prompt} : {})
            });
        };

        if (stepId) { // 新增主容器
            const taskName = data.data.taskName;
            const extra = data.data.extra
            if(taskName) {
                stepsContainer(stepId, taskName, parentStepId, extra);
            }
        }

        if (trigger === TriggerType.CONNECT_SUCCESS) {
            const isLock = data.data.isLock
            setLoading(isLock);
            let strategyCode = data.data.defaultStrategyCode
            const activeConversationIds = data.data.activeConversationIds
            if (activeConversationIds && activeConversationIds.length) {
                const extra = activeConversationIds[0].lastParserTaskCard?.extra;
                const conversationId = activeConversationIds[0].conversationId;
                if(boardId) syncActiveConversion(conversationId, boardId)
                if (extra) {
                    const resolveExtra = JSON.parse(extra);
                    if (resolveExtra.strategyCode) strategyCode = resolveExtra.strategyCode
                }
            }
            dispatch(setCurrentStrategyCode(strategyCode))
        }

        if (trigger === TriggerType.ADD_SUGGESTION) {
            const suggestions = data.data.suggestions
            dispatch(setPrefabricatedChat(suggestions))
        }

        if (trigger === TriggerType.LOCK) {
            setLoading(true);
        }

        if (trigger === TriggerType.UNLOCK) {
            dispatch(fetchMemberInfoAsync())
            setLoading(false);
        }

        if (trigger === TriggerType.ADD_TASK_CARD) {
            const directionInfo = getBatchInfo(data.data.batchId, data.data.cardIdPreGenerated);
            switch (command) {
                case 'analysis':
                    if (data.data) {
                        await fetchConversionList();
                        handleTaskStatus(CommandType.ANALYSIS);
                    }
                    break;
                case CommandType.PARSER_TASK_CARD:
                    if (data.data.status === TaskStatusType.EXECUTING) {
                        const content = JSON.parse(data.data.extra as unknown as string);
                        setLoading(true);
                        const useInfoStr = getLocalStorage('userInfo');
                        const localUserInfo = useInfoStr ? JSON.parse(useInfoStr) as LoginProps : null;

                        if (!level2TaskId){
                            setLabelToFrame(command, data.data.id, localUserInfo?.userName || '', stepId, directionInfo)
                            replaceDialogFrame(data.data.id, data.data.content, content.images)
                        }
                    }
                    handleTaskStatus(command);
                    break;

                case CommandType.CHAT:
                    if (data.data.status === TaskStatusType.EXECUTING) {
                        if (!level2TaskId){
                            setLabelToFrame(command, data.data.id, data.data.content, stepId, directionInfo)
                        }
                    }
                    handleTaskStatus(command);
                    break;

                case CommandType.GENERATE_TAGS:
                case CommandType.GENERATE_IMAGES:
                case CommandType.FETCH_IMAGES:
                case CommandType.GENERATE_PLANS:
                case CommandType.EDIT_IMAGES:
                    if (data.data.response && data.data.status === TaskStatusType.EXECUTING) { // 往画布添加执行状态卡片
                        const response = JSON.parse(data.data.response as unknown as string);
                        if (!level2TaskId){
                            setLabelToFrame(command, data.data.id, response.note, stepId, directionInfo)
                        }
                    }
                    handleTaskStatus(command);
                    break;

                default:
                    console.log(`未知事件类型 ${command}`);
            }
        }

        if (trigger === TriggerType.CONVERSION_CREATE) {
            if (data.data) {
                const conversionId = data.data.conversionId;
                setLocalStorage('conversionId', conversionId, boardId as string);
                const imageUuid = selectCanvasImage?.map(src => {
                    return src.split('/').reverse()[0]
                }) ?? []
                if (prompt || imageUuid.length) analysis(conversionId, prompt, imageUuid, parentStepId, styleDetail?.strategyCode);
                dispatch(setSelectCanvasImage(null));
            }
        }

        if (trigger === TriggerType.UPDATE_CONVERSION_STATUS) {
            if (data.data) {
                changeTaskListProcess(data.data.status);
            }
        }

        if (trigger === TriggerType.UPDATE_TASK_CARD_STATUS) {
            const status = data.data.status;
            const taskId = data.data.taskId;
            const response = data.data.response ? JSON.parse(data.data.response) : null;

            const taskName = getTaskName(taskId);

            if ((CommandType.GENERATE_TAGS === taskName || CommandType.GENERATE_PLANS === taskName) && response) {
                if (!level2TaskId) {
                    replaceLabelsFrame(taskId, response.data, response.msg)
                }
            }

            if (CommandType.FETCH_IMAGES === taskName && response) {
                if (!level2TaskId) {
                    replaceImagesFrame(taskId, response.data, CommandType.FETCH_IMAGES, response.msg)
                }
            }

            if (CommandType.GENERATE_IMAGES === taskName && response) {
                if (!level2TaskId) {
                    replaceImagesFrame(taskId, response.data, CommandType.GENERATE_IMAGES, response.msg)
                }
            }

            if (CommandType.EDIT_IMAGES === taskName && response) {
                if (!level2TaskId) {
                    replaceImagesFrame(taskId, response.data, CommandType.EDIT_IMAGES, response.msg)
                }
            }

            if (CommandType.CHAT === taskName && response) {
                if (!level2TaskId) {
                    replaceDescribeFrame(taskId, response.content, CommandType.CHAT, response.msg)
                }
            }

            if (response) {
                if (redrawYAxisRef.current) {
                    cancelAnimationFrame(redrawYAxisRef.current);
                }

                redrawYAxisRef.current = requestAnimationFrame(() => {
                    redrawYAxis(taskId);
                    redrawYAxisRef.current = null;
                });
            }

            const taskIdExist = taskProcessCacheRef.current?.find((taskProcess) => taskProcess.id === taskId);
            if (taskIdExist) {
                changeTaskProcess(taskId as number, response ? {status, response} : {status})
            }

        }

        if (trigger === TriggerType.ADD_BATCH) {
            handleTaskStatus(command);
        }

        if (trigger === TriggerType.SERVER_PUSH_IMAGE) {
            const originUrl = data.src;
            const blob = data.blob;
            const shapeId = data.data.req.extra.shapeId;
            if (originUrl && shapeId) {
                replaceDomImageSrc(shapeId, originUrl, true, blob)
            }
        }

        if (trigger === TriggerType.UPDATE_STEP_STATUS) {
            setLoading(false);
            fitFrameContainer(stepId)
        }
    };

    const updateTaskParamsForTaskId = async (taskId?: number, extra?: ExtraProps) => {
        const findTask = taskProcessCache?.find(item => item.id === taskId);
        const data = extra ? {...findTask, extra} as taskProcess : findTask
        taskId && await updateTaskParams(taskId, data)
    }

    const updateStatus = async (taskId?:number, status?: TaskStatusType, extra?: ExtraProps) => {
        if (status === TaskStatusType.COMPLETED || status === TaskStatusType.CANCELED) {
            await updateTaskParamsForTaskId(taskId, extra)
        }
        await updateTaskStatus(taskId, status, clientId)
    }

    useEffect(()=>{ // 获取当前需要执行的step以及状态更新
        const planTask = [...(taskProcessCache || [])].reverse()?.find(task => task.triggerCmd === CommandType.ANALYSIS);
        if (!planTask) return;
        const conversionItem = planTask?.status ? JSON.parse(planTask.status) : null;
        if (conversionItem.selfStatus === TaskStatusType.CANCELED) return;

        const taskData = (planTask?.response as analysisTaskProcess)?.data;

        if (!taskData) return;

        let containerToBeGenerated: AnalysisTaskSubProcess | null = null;
        if (!conversionItem) containerToBeGenerated = taskData[0]

        const taskNotCompleted = Object.keys(conversionItem?.stepStatus).find(ste => {
            const stepStatus = conversionItem?.stepStatus[ste];
            return  stepStatus !== TaskStatusType.COMPLETED;
        })

        const hasExcuseTask = Object.keys(conversionItem?.stepStatus).find(ste => { // 是否存在还在执行的任务
            const stepStatus = conversionItem?.stepStatus[ste];
            return  stepStatus === TaskStatusType.EXECUTING;
        })

        // 更新主容器label状态
        Object.keys(conversionItem?.stepStatus).forEach((ste) => {
            const stepStatus = conversionItem?.stepStatus[ste];
            updateMainContainerStatus(stepStatus, ste as CommandType, planTask?.id)
        })

        if (taskNotCompleted || hasExcuseTask) return;

        const findExcuseTaskIndex = taskData.findIndex(item => !conversionItem?.stepStatus[item.toolName]);
        if (findExcuseTaskIndex > -1) containerToBeGenerated = taskData[findExcuseTaskIndex]

        if (containerToBeGenerated && !level2TaskId) {
            // stepsProcess(containerToBeGenerated.note, findExcuseTaskIndex + 1, TaskStatusType.PENDINGEXECUTION, containerToBeGenerated.toolName as CommandType, planTask?.id, taskProcessCache as taskProcess[]);
        }

    },[taskProcessCache, editor, level2TaskId])

    useEffect(() => {
        if (!editor) return ;
        if (!triggerChangeSet) return;
        const handleOpen = () => {
            const version = getCurrentVersion(boardId as string);
            if ((version || boardInfo?.type === 'FORKED') && clientId && boardId) {
                getChangeSetList(boardId as string, version, '', 'drag').then()
            }else {
                isPullLock.current = false;
                isProcessing.current = false;
            }
        };

        handleOpen();

        socketService.on('open', handleOpen);

        return () => {
            socketService.off('open', handleOpen);
        };
    }, [editor, clientId, boardId, boardInfo, triggerChangeSet]);

    const changeLoadingStatus = (loading: boolean) => {
        setLoading(loading)
    }

    useEffect(() => {
        if (globalMessage) {
            setLoading(true)
            const hoverChatDom = document.getElementById('hover-chat');
            if (socketService.isConnected && hoverChatDom) {
                setPrompt(globalMessage)
                getConversionId(globalMessage);
            } else {
                const interval = setInterval(() => {
                    const hoverChatDom = document.getElementById('hover-chat');
                    if (socketService.isConnected && hoverChatDom) {
                        setTimeout(()=>{
                            setPrompt(globalMessage)
                            getConversionId(globalMessage);
                            clearInterval(interval);
                        })
                    }
                }, 500);

                return () => {
                    clearInterval(interval);
                };
            }
        }
    }, [globalMessage]);


    const getChangeSetList = async (boardId: string, versionId?: number, specifyVersions?: string, tag?: string) => {
        // @ts-ignore
        let [majorReversion, minorReversion] = versionId.toString().split('.').map(Number);

        const items = await getChangeSet(boardId, majorReversion, specifyVersions, tag, minorReversion);

        await sleep(1000);

        isPullLock.current = false;
        isProcessing.current = false;

        const data = items.flatMap(events => {
            const parsed = JSON.parse(events.eventData);
            return parsed.trigger === 'batchEventPush'
                ? parsed.data.map((event: any, index: number) => ({...parsed, ...event, reversion: `${parsed.reversion}.${index}`}))
                : parsed;
        });

        enqueueMessage(data, true);
    };

    const getChangeSetListReload = async (boardId: string, versionId?: number, specifyVersions?: string, tag?: string) => {

        isProcessing.current = true;

        // @ts-ignore
        const [majorReversion, minorReversion] = versionId.toString().split('.').map(Number);

        const items = await getChangeSet(boardId, majorReversion, specifyVersions, tag, minorReversion);
        isProcessing.current = false;

        const data = items.flatMap(events => {
            const parsed = JSON.parse(events.eventData);
            return parsed.trigger === 'batchEventPush'
                ? parsed.data.map((event: any, index: number) => ({...parsed, ...event, reversion: `${parsed.reversion}.${index}`}))
                : parsed;
        });

        enqueueMessage(data, true);
    };


    const contextValue = {
        snackbarOpen: snackbarOpen.open,
        conversionId,
        handleSetTaskProcess,
        taskProcess: taskProcessCache,
        loading,
        handleSetPrompt,
        taskListProcess: taskListProcessCache,
        updateStatus,
        changeTaskProcess,
        conversionValue,
        editor,
        conversionHistoryDetail,
        updateTaskParamsForTaskId,
        changeLoadingStatus,
    }

    useEffect(()=>{
      if(!boardId) navigate('/dashboard')
/*        getCategory().then(item=>{
            const allList = item?.map(list=>{
                return getStyleList(list.typeCode)
            })

            if(allList && item) {
                dispatch(setStyleCategory(item))
                Promise.all(allList)
                .then(results => {
                    const listDetail = results.map((list, index) => {
                        const category = item[index];
                        return {...category, list};
                    })

                    if(listDetail) {
                        dispatch(setStyleList(listDetail))
                    }
                })
                .catch(error => {
                    console.error('有一个或多个请求失败:', error);
                });
            }
        })*/
    },[boardId])

    const { t } = useTranslation();

    return <>
        <TaskFlowContext.Provider value={contextValue}>
            <div style={{position: 'fixed', top: 15, right: 285, zIndex: 999, cursor: 'pointer', background: "bisque", padding: 9, borderRadius: 10, display: 'none'}} onClick={() => {
                updateReversion(0, boardId as string)
                getChangeSetListReload(boardId as string, 0, '', 'reload').then()
            }}>重放
            </div>
            <div className='chatHistoryIcon' onClick={() => {
                controlHistory(1)
            }}><ContentPasteSearchIcon style={{color: 'var(--c-text-primary)'}}/></div>
            <div className='hangingChatContain'><HangingChat controlHistory={controlHistory}/></div>
            <HoverChatButton/>
            <HoverChatButtonForCard />
            <HoverChatButtonForImage />
            {/*<HoverChat/>*/}
            <Fade in={!!openHistoryTab} timeout={300}>
                <Box className='chatBox'>
                    <Tabs value={conversionValue} onChange={handleChange} style={{position: 'relative'}}
                          aria-label="disabled tabs example" centered>
                        <Tab label="对话" style={{marginRight: 40, display: 'none'}}/>
                        <Tab label={t('history_label')}/>
                        <div style={{position: "absolute", right: "8px", top: "3px"}}>
                            <IconButton onClick={() => {
                                controlHistory(0)
                            }} aria-label="close">
                                <CloseIcon/>
                            </IconButton>
                        </div>
                    </Tabs>
                    <TaskManage/>
                    {conversionValue === ConversionType.CONVERSING && <Chat/>}
                </Box>
            </Fade>
        </TaskFlowContext.Provider>
    </>
}